// var tablesaw = require('tablesaw');

//
// init
//

$(document).ready(function () {
	/*! Tablesaw - v2.0.2 - 2015-10-28
	* https://github.com/filamentgroup/tablesaw
	* Copyright (c) 2015 Filament Group; Licensed  */
	// ;(function( $ ) {

		// DOM-ready auto-init of plugins.
		// Many plugins bind to an "enhance" event to init themselves on dom ready, or when new markup is inserted into the DOM
		$(function() {
			$(document).trigger( "enhance.tablesaw" );
		});

	// })( jQuery );

	$('.js-table-responsive').each(function (index, el) {
		var $this = $(this),
			typeTable = $this.attr('data-table-type'),
			$thisTable = $this.find('table');

		$thisTable
			.attr('data-tablesaw-mode', typeTable)
			.trigger('enhance.tablesaw');
	});
});



// WEBPACK FOOTER //
// ./frontend/components/table-responsive/table-responsive.js